import React from "react"
import styles from './aboutSection.module.css';
import table from './images/table.png'
import gamemaster from './images/gamemaster.jpg'
import tableMobile from './images/imageMobile.png'
import {FadeInUp} from "../../shared/ui/animations";
import FadeIn from "../../shared/ui/animations/FadeIn.jsx";

class AboutSection extends React.Component {
    render() {
        return (
            <section className={`container-custom`} id="aboutSection">
                <FadeInUp delay={100}>
                    <p className="body section-title">О нас</p>
                </FadeInUp>
                <div className={styles.desctopDescription}>
                    <div className={`text-start text-md-end`}>
                        <FadeInUp delay={150}>
                            <h2 className={`me-md-4`}>
                                «Подземелье» – это уютное место
                                <span className="br-hide"><br/></span>
                                для встреч любителей настольно-ролевых игр.
                            </h2>
                        </FadeInUp>
                    </div>
                    <div className={`row g-0`}>
                        <div className="col-lg-3 col-1"></div>
                        <div className={`col-lg-6 col-10 row`}>
                            <FadeIn delay={300}>
                                <p className={`${styles.description} body col`}>
                                    Здесь ты сможешь воплотить в жизнь мечту – оказаться в мире любимых героев,
                                    стать отважным приключенцем, встретить Гарри Поттера, попасть на Звезду Смерти из "Звездных войн",
                                    сесть на Железный трон в мире "Игры Престолов", побеждать огнедышащих драконов,
                                    спасать прекрасных принцесс, отмечать свои подвиги в ближайшей таверне и заниматься
                                    практически всем, на что хватит фантазии.
                                </p>
                            </FadeIn>
                            <FadeIn delay={300}>
                                <p className={`${styles.description} body col`}>
                                    Настольно-ролевая игра – это возможность не просто наблюдать за сюжетом,
                                    а стать его главным героем; возможность есть взаимодействовать с другими персонажами и целой вселенной,
                                    которую создаст Мастер для тебя и твоих друзей. Мы уже сделали счастливыми сотни игроков и будем рады видеть
                                    тебя в числе наших новых героев. Скорее приходи, чтобы стать частью захватывающих приключений!
                                </p>
                            </FadeIn>
                        </div>
                        <div className="col-lg-3 col-1"></div>

                    </div>
                    <div className={styles.images + " row g-0"}>
                        <div className="col-md-3"></div>
                        <FadeIn delay={500}>
                            <div className="col-md-6 px-1">
                                <img className="img-fluid h-100" src={table} alt="table"/>
                            </div>
                            <div className="col-md-3 px-1 hideImg">
                                <img className="img-fluid h-100" src={gamemaster} alt=""/>
                            </div>
                        </FadeIn>
                    </div>
                </div>

                <div className={styles.mobileDescription}>
                    <div className={`text-start text-md-end`}>  {/*${styles.heading} */}
                        <FadeInUp delay={150}>
                            <h2 className={`me-md-4`}>
                                «Подземелье» – это уютное место для встреч любителей настольно-ролевых игр.
                            </h2>
                        </FadeInUp>
                    </div>
                    <FadeIn delay={300}>
                        <p className={`${styles.description} body`}>
                            Здесь ты сможешь воплотить в жизнь мечту – оказаться в мире любимых героев,
                            стать отважным приключенцем, встретить Гарри Поттера, попасть на Звезду Смерти из "Звездных войн",
                            сесть на Железный трон в мире "Игры Престолов", побеждать огнедышащих драконов,
                            спасать прекрасных принцесс, отмечать свои подвиги в ближайшей таверне и заниматься
                            практически всем, на что хватит фантазии.
                        </p>
                    </FadeIn>
                    <FadeIn delay={400}>
                        <div className={styles.imageMobile}>
                            <img className="img-fluid h-100" src={tableMobile} alt="table"/>
                        </div>
                    </FadeIn>
                    <FadeIn delay={300}>
                        <p className={`${styles.description} body`}>
                            Настольно-ролевая игра – это возможность не просто наблюдать за сюжетом,
                            а стать его главным героем; возможность есть взаимодействовать с другими персонажами и целой вселенной,
                            которую создаст Мастер для тебя и твоих друзей. Мы уже сделали счастливыми сотни игроков и будем рады видеть
                            тебя в числе наших новых героев. Скорее приходи, чтобы стать частью захватывающих приключений!
                        </p>
                    </FadeIn>
                </div>
            </section>
        )
    }
}

export default AboutSection;